// extracted by mini-css-extract-plugin
export default {"root":"PrivacyPolicy_root__JdESl","container":"PrivacyPolicy_container__6q4VO","list":"PrivacyPolicy_list__TVtJv"};